module.exports = __webpack_public_path__ + "assets/pregunta.41771275bd8b21f62f78f996a51bafed.png";


//////////////////
// WEBPACK FOOTER
// ./img/landingPage/pregunta.png
// module id = 889
// module chunks = 0